import { useEffect, useState, useCallback, useMemo } from "react";
import { fetchAcademicYear } from "../services/class_routine";

const PAGE_SIZE = 20;

export const useAcademicYears = () => {
  const [yearList, setYearList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [hasMoreYear, setHasMoreYear] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchYears = useCallback(async (page = 1, append = false) => {
    try {
      setLoading(true);
      const payload = {
        page,
        pageSize: PAGE_SIZE,
      };

      const response = await fetchAcademicYear(payload);
      const years = response?.data?.data?.academicYears || [];
      const totalCount = response?.data?.data?.totalRecords || 0;
      const reachedEnd = page * PAGE_SIZE >= totalCount;
      setHasMoreYear(!reachedEnd);
      setYearList((prev) => (append ? [...prev, ...years] : years));
    } catch (err) {
      console.error("Failed to fetch academic years", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Set active year automatically //
  useEffect(() => {
    if (yearList?.length && !selectedYear) {
      const active = yearList?.find((y) => y?.active_year);
      setSelectedYear(active?.id ?? null);
    }
  }, [yearList]);

  useEffect(() => {
    fetchYears();
  }, [fetchYears]);

  // Infinite scroll handler //
  const onPopupScroll = (e) => {
    const el = e.currentTarget;
    const reachedBottom =
      el.scrollTop + el.offsetHeight >= el.scrollHeight - 10;

    if (reachedBottom && !loading && hasMoreYear) {
      const nextPage = pageNo + 1;
      setPageNo(nextPage);
      fetchYears(nextPage, true);
    }
  };

  // Year selection handler //
  const onChangeSelectedYear = (id) => {
    setPageNo(1);
    setSelectedYear(id);
  };

  const selectedYearName = useMemo(() => {
    return yearList?.find(y => y?.id === selectedYear)?.name || "";
  }, [yearList, selectedYear]);

  const activeAcademicYear = useMemo(() => {
    return yearList?.find((y) => y?.active_year) || null;
  }, [yearList]);

  return {
    yearList,
    selectedYear,
    selectedYearName,
    activeAcademicYear,
    onChangeSelectedYear,
    loading,
    hasMoreYear,
    onPopupScroll,
  };
};
